import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createSlots as _createSlots, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex align-center" };
const _hoisted_2 = { class: "d-flex" };
const _hoisted_3 = { ref: "embed" };
const _hoisted_4 = { class: "d-flex" };
const _hoisted_5 = { class: "body2-text mt-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_select = _resolveComponent("v-select");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_dialog = _resolveComponent("v-dialog");
    const _component_vue_datepicker_action_row = _resolveComponent("vue-datepicker-action-row");
    const _component_vue_datepicker = _resolveComponent("vue-datepicker");
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    const _directive_btn_style = _resolveDirective("btn-style");
    return (_openBlock(), _createElementBlock("div", null, [
        _createCommentVNode(" 이름 "),
        _createVNode(_component_InputRow, {
            "data-cy": "worker-name-input-row",
            label: _ctx.$t(`${_ctx.lc}worker_name`),
            "is-required": "",
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                    ref: "nameRef",
                    modelValue: _ctx.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.name) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "auto",
                    "validate-on": "blur",
                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '이름' }),
                    rules: _ctx.formRules.name
                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "rules"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 사번 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_employee_number`),
            "is-required": "",
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                    ref: "hubEmployeeNumberRef",
                    modelValue: _ctx.hubEmployeeNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.hubEmployeeNumber) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "auto",
                    "validate-on": "blur",
                    "error-messages": _ctx.errorMessageData.hubEmployeeNumberExistence,
                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '사번' }),
                    rules: _ctx.formRules.hubEmployeeNumber,
                    onBlur: _cache[2] || (_cache[2] = ($event) => (_ctx.onBlurHubEmployeeNumberField(_ctx.hubEmployeeNumber)))
                }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                    (_ctx.isCheckedHubEmployeeNumberExistence)
                        ? {
                            name: "append-inner",
                            fn: _withCtx(() => [
                                (_ctx.errorMessageData.hubEmployeeNumberExistence)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        color: "red"
                                    }, {
                                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                                            _createTextVNode(" mdi-close ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [24]
                                    }))
                                    : (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 1,
                                        color: "green"
                                    }, {
                                        default: _withCtx(() => _cache[25] || (_cache[25] = [
                                            _createTextVNode(" mdi-check ")
                                        ])),
                                        _: 1 /* STABLE */,
                                        __: [25]
                                    }))
                            ]),
                            key: "0"
                        }
                        : undefined
                ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "error-messages", "placeholder", "rules"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 고용형태 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_employee_type`),
            "is-required": "",
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_select, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.employeeType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.employeeType) = $event)),
                    items: _ctx.employeeTypeOptions,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto"
                }, null, 8 /* PROPS */, ["modelValue", "items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 보수지급방식 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}salary_type`),
            "is-required": "",
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_select, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.salaryType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.salaryType) = $event)),
                    items: _ctx.salaryTypeOptions,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto"
                }, null, 8 /* PROPS */, ["modelValue", "items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode("단말기번호의 경우 등록은 가능하나, 실명인증으로 수정불가로 변경됨 (기사 핸드폰에서만 수정 가능)"),
        _createCommentVNode(" 대체연락처 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}tel_number`),
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                    modelValue: _ctx.telNumber,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.telNumber) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "auto",
                    inputmode: "numeric",
                    "validate-on": "blur",
                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '연락처' }),
                    maxlength: _ctx.PHONE_MAX_LENGTH,
                    rules: _ctx.formRules.telNumber,
                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );"
                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "maxlength", "rules"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 라이더 상태 "),
        _createCommentVNode(" https://www.notion.so/barogohq/useYn-bb1a11da3e2c40af97eb72d48b89d329?pvs=4 (등록은 제외하고 수정에서만 사용)"),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_use_yn_type`),
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_select, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.useYn,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.useYn) = $event)),
                    items: _ctx.workerUseYnTypeOptions,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto",
                    placeholder: _ctx.$t('common.select_field_placeholder', { field: '상태' })
                }, null, 8 /* PROPS */, ["modelValue", "items", "placeholder"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 근무시간 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}work_time`),
            "is-required": "",
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_text_field, {
                        modelValue: _ctx.workTimeOn,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.workTimeOn) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        type: "time",
                        suffix: _ctx.$t(`common.on`),
                        onBlur: _cache[8] || (_cache[8] = ($event) => (_ctx.onBlurWorkTimeField('on')))
                    }, null, 8 /* PROPS */, ["modelValue", "suffix"]),
                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "mx-2" }, [
                        _createElementVNode("span", null, "~")
                    ], -1 /* CACHED */)),
                    _createVNode(_component_v_text_field, {
                        modelValue: _ctx.workTimeOff,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.workTimeOff) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        type: "time",
                        suffix: _ctx.$t(`common.off`),
                        onBlur: _cache[10] || (_cache[10] = ($event) => (_ctx.onBlurWorkTimeField('off')))
                    }, null, 8 /* PROPS */, ["modelValue", "suffix"])
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 주소 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}home_address`),
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_text_field, {
                        modelValue: _ctx.currentAddress,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.currentAddress) = $event)),
                        placeholder: _ctx.$t(`${_ctx.changePostcodeLc}search_postcode`),
                        variant: "outlined",
                        "hide-details": "auto",
                        density: "compact",
                        class: "grow",
                        filled: !_ctx.currentAddress,
                        disabled: !_ctx.currentAddress,
                        maxlength: _ctx.ADDRESS_MAX_LENGTH
                    }, null, 8 /* PROPS */, ["modelValue", "placeholder", "filled", "disabled", "maxlength"]),
                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                        "hide-details": "auto",
                        class: "ml-2",
                        onClick: _ctx.handleClickPostcode
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                                small: "",
                                class: "pr-1"
                            }, {
                                default: _withCtx(() => _cache[27] || (_cache[27] = [
                                    _createTextVNode(" mdi-magnify ")
                                ])),
                                _: 1 /* STABLE */,
                                __: [27]
                            }),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.changePostcodeLc}search_postcode`)), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])), [
                        [
                            _directive_btn_style,
                            void 0,
                            "config",
                            {
                                info: true,
                                outlined: true,
                                large: true,
                                "size-l": true
                            }
                        ]
                    ])
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createVNode(_component_v_dialog, {
            modelValue: _ctx.postcodeDialog,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.postcodeDialog) = $event)),
            "content-class": "responsive-dialog"
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_DialogHeader, {
                            title: _ctx.$t(`${_ctx.changePostcodeLc}search_postcode`),
                            "on-cancel": _ctx.handleClickCancelPostcode
                        }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                        _createElementVNode("div", _hoisted_3, null, 512 /* NEED_PATCH */)
                    ]),
                    _: 1 /* STABLE */
                })
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createCommentVNode(" 라이더 유형 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_type`),
            "is-required": "",
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                    modelValue: _ctx.type,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.type) = $event)),
                    filled: "",
                    disabled: "",
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto",
                    onKeyup: _cache[14] || (_cache[14] = ($event) => ($event.stopPropagation())),
                    onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.onBlurWorkerTypeField(_ctx.type)))
                }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 입사일 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_registration_date`),
            "is-required": "",
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_vue_datepicker, {
                    class: "block",
                    modelValue: _ctx.currentWorkerRegDate,
                    "onUpdate:modelValue": [
                        _cache[17] || (_cache[17] = ($event) => ((_ctx.currentWorkerRegDate) = $event)),
                        _ctx.handleClickPickerRegSubmit
                    ],
                    "model-type": "yyyy-MM-dd",
                    format: "yyyy-MM-dd"
                }, {
                    "action-row": _withCtx((props) => [
                        _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */)
                    ]),
                    "dp-input": _withCtx(() => [
                        _createVNode(_component_v_text_field, {
                            modelValue: _ctx.updateFormData.workerRegDate,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.updateFormData.workerRegDate) = $event)),
                            variant: "outlined",
                            density: "compact",
                            readonly: "",
                            "hide-details": "auto",
                            "bg-color": "white",
                            "prepend-inner-icon": "mdi-calendar-month-outline",
                            rules: _ctx.formRules.workerRegDate
                        }, null, 8 /* PROPS */, ["modelValue", "rules"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 퇴사일 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}worker_leave_date`),
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.isWorkerLeaveDateUsed,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.isWorkerLeaveDateUsed) = $event)),
                        variant: "outlined",
                        density: "compact",
                        "hide-details": "auto",
                        items: _ctx.useOptionList,
                        "item-title": "label",
                        "item-value": "value",
                        style: { "max-width": "125px" }
                    }, null, 8 /* PROPS */, ["modelValue", "items"]),
                    _createVNode(_component_vue_datepicker, {
                        style: { "width": "140px" },
                        modelValue: _ctx.currentWorkerLeaveDate,
                        "onUpdate:modelValue": [
                            _cache[19] || (_cache[19] = ($event) => ((_ctx.currentWorkerLeaveDate) = $event)),
                            _ctx.handleClickPickerLeaveSubmit
                        ],
                        "model-type": "yyyy-MM-dd",
                        format: "yyyy-MM-dd",
                        "min-date": _ctx.atLeastRegDate
                    }, {
                        "action-row": _withCtx((props) => [
                            _createVNode(_component_vue_datepicker_action_row, _normalizeProps(_guardReactiveProps(props)), null, 16 /* FULL_PROPS */)
                        ]),
                        "dp-input": _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                                value: _ctx.updateFormData.workerLeaveDate,
                                class: "ml-2",
                                variant: "outlined",
                                density: "compact",
                                disabled: !_ctx.isWorkerLeaveDateUsed,
                                "hide-details": "auto",
                                "bg-color": "white",
                                "prepend-inner-icon": "mdi-calendar-month-outline"
                            }, null, 8 /* PROPS */, ["value", "disabled"])
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["modelValue", "min-date", "onUpdate:modelValue"])
                ])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 관리자 메모 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}memo`),
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                    modelValue: _ctx.memo,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.memo) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "auto",
                    "validate-on": "blur",
                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '메모' }),
                    maxlength: _ctx.MEMO_MAX_LENGTH
                }, null, 8 /* PROPS */, ["modelValue", "placeholder", "maxlength"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 예치금 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}deposit_baromoney`),
            "is-required": "",
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                    modelValue: _ctx.formattedDepositBaromoneyComputed,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.formattedDepositBaromoneyComputed) = $event)),
                    density: "compact",
                    variant: "outlined",
                    "hide-details": "auto",
                    inputmode: "numeric",
                    suffix: _ctx.$t('common.currency'),
                    maxlength: _ctx.DEPOSIT_BAROMONEY_MAX_LENGTH,
                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                    onBlur: _cache[22] || (_cache[22] = ($event) => (_ctx.onBlurDepositBaromoney(_ctx.formattedDepositBaromoneyComputed)))
                }, null, 8 /* PROPS */, ["modelValue", "suffix", "maxlength"]),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t(`${_ctx.lc}deposit_baromoney_info_text`)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"]),
        _createCommentVNode(" 결격여부 "),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}conviction_status`),
            "is-required": "",
            "head-col": _ctx.headCol
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.convictionStatusComputed,
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.convictionStatusComputed) = $event)),
                    inline: "",
                    density: "compact",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.convictionStatus, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: option.text,
                                value: option.key
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label", "head-col"])
    ]));
}
